import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import ReactImageMagnify from 'react-image-magnify';

function getClassName(props) {
  const classNames = [props.type];
  if (props.selected) classNames.push(`${props.type}--selected`);
  if (props.className) classNames.push(props.className);
  return classNames.join(' ');
}

function Image(props) {
  const myClass = getClassName(props);
  let elem =
    props.type === 'img-bg' ? (
      <div
        onClick={props.onClick}
        style={{ backgroundImage: `url(${props.src})` }}
        className={myClass}
        id={props.id}
        key={props.id}
        data-testid="ImageBg"
      />
    ) : (
      <img
        onClick={props.onClick}
        src={props.src}
        id={props.id}
        data-testid="Image"
        key={props.id}
        alt={props.src}
      />
    );
  if (props.srcLarge !== '') {
    // const srcSet = [
    //   { src: props.src, setting: '1020w' },
    //   { src: props.srcLarge, setting: '1200w' }
    // ]
    //   .map(item => `${item.src} ${item.setting}`)
    //   .join(', ');

    elem = (
      <ReactImageMagnify
        {...{
          smallImage: {
            alt: '',
            isFluidWidth: true,
            src: props.src
            // srcSet: srcSet,
            // sizes: '(max-width: 480px) 100vw, (max-width: 1200px) 30vw, 360px'
          },
          largeImage: {
            src: props.srcLarge,
            width: parseFloat(props.size.width),
            height: parseFloat(props.size.height)
          },
          lensStyle: { backgroundColor: 'rgba(0,0,0,.6)' },
          enlargedImagePosition: 'over'
        }}
      />
    );
  }
  return (
    <div className={props.containerClassName}>
      {props.path ? <NavLink to={props.path}>{elem}</NavLink> : elem}
    </div>
  );
}

Image.defaultProps = {
  id: null,
  className: '',
  containerClassName: 'pos-rel',
  type: 'img',
  selected: false,
  onClick: null,
  path: null,
  srcLarge: '',
  size: null
};

Image.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  src: PropTypes.string.isRequired,
  id: PropTypes.string,
  type: PropTypes.oneOf(['img', 'img-bg']),
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  path: PropTypes.string,
  srcLarge: PropTypes.string,
  size: PropTypes.object
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/ui/Image.jsx